import React from "react";
import ReactDOM from "react-dom/client";

import "@/styles/globals.css";
import "@/i18n";
// uiStore importa para aplicar tema antes do primeiro render
import "@/stores/uiStore";

import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
